class CustomNewsletter extends HTMLElement {
  lisTsd = "list-builderssss";

  connectedCallback() {
    this.popup = this.querySelector("[data-popup]");
    this.successWrapper = this.querySelector("[data-success]");
    this.delay = parseInt(this.getAttribute("data-delay") || 6, 10) * 1000;
    this.closeBtn = Array.from(this.querySelectorAll("[data-close]"));
    this.isTestMode = this.getAttribute("data-test") === "true";
    this.initListener();
    if (this.isTestMode) {
      this.open();
    } else {
      this.sync();
    }
  }

  sync() {
    if (this.successWrapper) {
      this.open();
      localStorage.setItem(this.lisTsd, Date.now());
      return;
    }

    var last = parseInt(localStorage.getItem(this.lisTsd) || "0", 10);
    var oneDay = 24 * 60 * 60 * 1000;
    if (Date.now() - last < oneDay) return; // shown within 24h — do nothing

    // Fire once on the user's first scroll, then wait the configured delay.
    window.addEventListener(
      "scroll",
      () => { setTimeout(() => this.open(), this.delay); },
      { once: true, passive: true }
    );
  }

  open() {
    this.popup.classList.add("isShow");
    const backdrop = this.querySelector(".newsletter-backdrop");
    if (backdrop) backdrop.classList.add("isShow");
  }

  close() {
    this.popup.classList.add("hidding");
    const backdrop = this.querySelector(".newsletter-backdrop");
    if (backdrop) backdrop.classList.remove("isShow");
    setTimeout(() => {
      this.popup.classList.remove("isShow");
      this.popup.classList.remove("hidding");
    }, 600);
    localStorage.setItem(this.lisTsd, Date.now());
  }

  initListener() {
    this.closeBtn.forEach((btn) =>
      btn.addEventListener("click", this.close.bind(this))
    );
    const backdrop = this.querySelector(".newsletter-backdrop");
    if (backdrop) backdrop.addEventListener("click", this.close.bind(this));
  }

  reset() {
    localStorage.removeItem(this.lisTsd);
  }
}
customElements.define("custom-newsletter", CustomNewsletter);